import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditMatchPayload {
    settingId: string
    data: any
}

export interface IEditMatchState {
    status: string
    data: any
    errors: any
}

const initialState: IEditMatchState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editMatch = createSlice({
    name: 'event-setting/edit-match',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditMatchPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editMatchActions = editMatch.actions
export default editMatch.reducer
